import { render, staticRenderFns } from "./RoomManagement.vue?vue&type=template&id=342f5346&scoped=true"
import script from "./RoomManagement.vue?vue&type=script&lang=js"
export * from "./RoomManagement.vue?vue&type=script&lang=js"
import style0 from "./RoomManagement.vue?vue&type=style&index=0&id=342f5346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342f5346",
  null
  
)

export default component.exports